import { createContext } from 'react';
var ContextMenuContext = createContext({});
export default ContextMenuContext;
//# sourceMappingURL=ContextMenuContext.js.map